<template>
    <button class="btn btn-link btn-sm text-muted btn-wishlist"
        @click.prevent="switchState()"
        data-toggle="tooltip"
        data-placement="top"
        ref="addToWishList"
        v-tooltip
        :title="tooltipText">
        <icon v-if="styleType === 2" icon="heart" class="default-float" :class="{'text-appearance text-danger': isVariationInWishList}" :loading="isLoading"></icon>
        <template v-if="styleType === 1">
            {{ $translate("Ceres::Template.singleItemWishList") }}
        </template>
        <template v-if="styleType === 3">
            {{ tooltipText }}
        </template>
        <template v-if="styleType === 4 && !isVariationInWishList">
            <div class="standard">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
                    <path id="heart-line" d="M19.142,34.491a1.071,1.071,0,0,1-.654-.225C12.532,29.638,8.428,25.652,5.557,21.72,1.893,16.7,1.057,12.056,3.071,7.931,4.507,4.985,8.632,2.574,13.453,3.977a10.575,10.575,0,0,1,5.689,4.039,10.575,10.575,0,0,1,5.689-4.039C29.642,2.6,33.778,4.985,35.214,7.931c2.014,4.125,1.179,8.764-2.486,13.789-2.871,3.932-6.975,7.918-12.932,12.546A1.071,1.071,0,0,1,19.142,34.491ZM10.71,5.724A6.321,6.321,0,0,0,5,8.863c-1.661,3.407-.911,7.2,2.293,11.582a61.21,61.21,0,0,0,11.85,11.614,61.21,61.21,0,0,0,11.85-11.6c3.214-4.393,3.954-8.186,2.293-11.582C32.214,6.731,29,5.027,25.421,6.034a8.571,8.571,0,0,0-5.293,4.5,1.071,1.071,0,0,1-1.982,0,8.5,8.5,0,0,0-5.293-4.5A7.832,7.832,0,0,0,10.71,5.724Z" transform="translate(12.857 14.979)" fill="#707070"/>
                    <g id="Ellipse_14" data-name="Ellipse 14" fill="none" stroke="#707070" stroke-width="2">
                        <circle cx="32" cy="32" r="32" stroke="none"/>
                        <circle cx="32" cy="32" r="31" fill="none"/>
                    </g>
                </svg>
            </div>
            <div class="hover">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
                    <g id="Ellipse_23" data-name="Ellipse 23" fill="#fff" stroke="#3c3c3c" stroke-width="2">
                        <circle cx="32" cy="32" r="32" stroke="none"/>
                        <circle cx="32" cy="32" r="31" fill="none"/>
                    </g>
                    <path id="heart-line" d="M19.142,34.491a1.071,1.071,0,0,1-.654-.225C12.532,29.638,8.428,25.652,5.557,21.72,1.893,16.7,1.057,12.056,3.071,7.931,4.507,4.985,8.632,2.574,13.453,3.977a10.575,10.575,0,0,1,5.689,4.039,10.575,10.575,0,0,1,5.689-4.039C29.642,2.6,33.778,4.985,35.214,7.931c2.014,4.125,1.179,8.764-2.486,13.789-2.871,3.932-6.975,7.918-12.932,12.546A1.071,1.071,0,0,1,19.142,34.491ZM10.71,5.724A6.321,6.321,0,0,0,5,8.863c-1.661,3.407-.911,7.2,2.293,11.582a61.21,61.21,0,0,0,11.85,11.614,61.21,61.21,0,0,0,11.85-11.6c3.214-4.393,3.954-8.186,2.293-11.582C32.214,6.731,29,5.027,25.421,6.034a8.571,8.571,0,0,0-5.293,4.5,1.071,1.071,0,0,1-1.982,0,8.5,8.5,0,0,0-5.293-4.5A7.832,7.832,0,0,0,10.71,5.724Z" transform="translate(12.857 14.979)" fill="#3c3c3c" stroke="#3c3c3c" stroke-width="1"/>
                </svg>
            </div>
            <div class="t-small">{{ $translate("Ceres::Template.singleItemWishList") }}</div>
        </template>
        <template v-if="styleType === 4 && isVariationInWishList">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
                <path id="heart-line" d="M19.142,34.491a1.071,1.071,0,0,1-.654-.225C12.532,29.638,8.428,25.652,5.557,21.72,1.893,16.7,1.057,12.056,3.071,7.931,4.507,4.985,8.632,2.574,13.453,3.977a10.575,10.575,0,0,1,5.689,4.039,10.575,10.575,0,0,1,5.689-4.039C29.642,2.6,33.778,4.985,35.214,7.931c2.014,4.125,1.179,8.764-2.486,13.789-2.871,3.932-6.975,7.918-12.932,12.546A1.071,1.071,0,0,1,19.142,34.491Z" transform="translate(12.857 14.979)" fill="#cd5e5b"/>
                <g id="Ellipse_26" data-name="Ellipse 26" fill="none" stroke="#707070" stroke-width="2">
                    <circle cx="32" cy="32" r="32" stroke="none"/>
                    <circle cx="32" cy="32" r="31" fill="none"/>
                </g>
            </svg>
            <div class="t-small">{{ $translate("Ceres::Template.singleItemWishList") }}</div>
        </template>
    </button>
</template>

<script>
import { isNullOrUndefined } from "../../helper/utils";
import { mapState } from "vuex";

const NotificationService = require("../../services/NotificationService");

export default {

    name: "add-to-wish-list",

    props: {
        variationId: Number,
        styleType: {
            type: Number,
            default: 1
        }
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data()
    {
        return {
            isLoading: false
        };
    },

    computed:
    {
        isVariationInWishList()
        {
            return this.wishListIds.includes(this.currentVariationId);
        },

        currentVariationId()
        {
            return !isNullOrUndefined(this.variationId) ? this.variationId : this.currentVariationVariationId;
        },

        currentVariationVariationId()
        {
            const currentVariation = this.$store.getters[`${this.itemId}/currentItemVariation`];

            if (isNullOrUndefined(currentVariation))
            {
                return null;
            }

            return currentVariation && currentVariation.variation && currentVariation.variation.id;
        },

        tooltipText()
        {
            const tooltipText = this.$translate(
                "Ceres::Template." + (this.isVariationInWishList ? "singleItemWishListRemove" : "singleItemWishListAdd")
            );


            return tooltipText;
        },

        ...mapState({
            wishListIds: state => state.wishList.wishListIds
        })
    },

    methods:
    {
        switchState()
        {
            if (this.isVariationInWishList)
            {
                this.removeFromWishList();
            }
            else
            {
                this.addToWishList();
            }
        },

        addToWishList()
        {
            if (!this.isLoading)
            {
                this.isLoading = true;
                this.$store.dispatch("addToWishList", parseInt(this.currentVariationId)).then(
                    response =>
                    {
                        this.isLoading = false;

                        NotificationService.success(
                            this.$translate("Ceres::Template.singleItemWishListAdded")
                        ).closeAfter(3000);
                    },
                    error =>
                    {
                        this.isLoading = false;
                    });
            }
        },

        removeFromWishList()
        {
            if (!this.isLoading)
            {
                this.isLoading = true;
                this.$store.dispatch("removeWishListItem", { id: parseInt(this.currentVariationId) }).then(response =>
                    {
                        this.isLoading = false;

                        NotificationService.success(
                            this.$translate("Ceres::Template.singleItemWishListRemoved")
                        ).closeAfter(3000);
                    },
                    error =>
                    {
                        this.isLoading = false;
                    });
            }
        }
    }
}

</script>
